<div class="header-container" [ngClass]="{'edit-mode-header-container': edit}">
  <div class="top-buttons">
    <div class="float-left">
      <back-button
        [title]="'BACK TO MAM'"
        [url]="'/mam/uploadReport'"
        [backgroundClass]="'bg-pale-white'"
      ></back-button>
    </div>
    <div class="float-right">
      <a
        *ngIf="edit"
        class="btn btn-export btn-export-big"
        (click)="updateDynamicPromo()"
        >Save Promo</a
      >
    </div>
  </div>
</div>
<div
  *ngIf="!!dynamicPromoInfo && isLoadingFinished"
  class="dynamic-promo-container"
>
  <div class="main-container" [ngClass]="{'edit-mode-main-container': edit}">
    <div class="edit-name-field">
      <input
        type="text"
        class="label header-text"
        *ngIf="edit && !!dynamicPromoInfo"
        [(ngModel)]="dynamicPromoInfo.name"
      />
      <div class="edit-icon"></div>
    </div>
    <div
      class="add-graphics-container"
      id="graphics-container"
      *ngIf="!edit"
      (click)="chooseGraphic()"
      (dragover)="$event.preventDefault()"
      (dragenter)="onDragEnter('graphics')"
      (dragleave)="onDragLeave('graphics')"
      (drop)="onGraphicDropped($event)"
      (mouseenter)="onGraphicsMouseEnter()"
      (mouseleave)="onGraphicsMouseLeave()"
      [ngStyle]="{'background-image': !!dynamicPromoInfo.graphicsInfo ? 'url(' + dynamicPromoInfo.graphicsInfo.thumbnail + ')' : false}"
    >
      <div class="add-graphics-inner-container">
        <div *ngIf="!dynamicPromoInfo.graphicsInfo" class="oval">
          <div class="add-graphics-icon" [inlineSVG]="graphicsIcon"></div>
        </div>
        <div
          *ngIf="!dynamicPromoInfo.graphicsInfo"
          class="dynamic-promo-add-text-main"
        >
          Add Graphics
        </div>
        <div
          *ngIf="!dynamicPromoInfo.graphicsInfo"
          class="dynamic-promo-add-text-secondary"
        >
          Choose graphics from library
        </div>
      </div>
    </div>

    <div
      *ngIf="edit"
      class="edit-dynamic-promo-graphics-container"
      (dragover)="$event.preventDefault()"
      (dragenter)="onDragEnter('graphics')"
      (dragleave)="onDragLeave('graphics')"
      (drop)="onGraphicDropped($event)"
    >
      <div class="edit-dp-graphics-header-container">
        <div class="edit-dp-graphics-header-main">
          {{dynamicPromoInfo.graphicsInfo.name}}
        </div>
        <div
          class="edit-dp-graphics-header-secondary"
          (click)="chooseGraphic()"
        >
          Replace Graphics
        </div>
      </div>
      <div class="add-graphics-container-edit-mode">
        <video-container
          [videoUrl]="dynamicPromoInfo.graphicsInfo.sampleVideo"
        ></video-container>
      </div>
    </div>

    <div
      class="add-media-container"
      id="media-container"
      *ngIf="!edit"
      (click)="chooseMedia()"
      (dragover)="$event.preventDefault()"
      (dragenter)="onDragEnter('media')"
      (dragleave)="onDragLeave('media')"
      (drop)="onMediaDropped($event)"
      (mouseenter)="onMediaMouseEnter()"
      (mouseleave)="onMediaMouseLeave()"
      [ngStyle]="{'background-image': !!dynamicPromoInfo.mediaInfo ? 'url(' + dynamicPromoInfo.mediaInfo.contentSnapshotUrl + ')' : false}"
    >
      <div class="add-graphics-inner-container">
        <div *ngIf="!dynamicPromoInfo.mediaInfo" class="oval">
          <div class="add-media-icon" [inlineSVG]="mediaIcon"></div>
        </div>
        <div
          *ngIf="!dynamicPromoInfo.mediaInfo"
          class="dynamic-promo-add-text-main"
        >
          Add Media
        </div>
        <div
          *ngIf="!dynamicPromoInfo.mediaInfo"
          class="dynamic-promo-add-text-secondary"
        >
          Choose media from library
        </div>
      </div>
    </div>

    <div
      *ngIf="edit"
      class="edit-dynamic-promo-graphics-container"
      (dragover)="$event.preventDefault()"
      (dragenter)="onDragEnter('media')"
      (dragleave)="onDragLeave('media')"
      (drop)="onMediaDropped($event)"
    >
      <div class="edit-dp-graphics-header-container">
        <div class="edit-dp-graphics-header-main">
          {{dynamicPromoInfo.mediaInfo.name}}
        </div>
        <div class="edit-dp-graphics-header-secondary" (click)="chooseMedia()">
          Replace Media
        </div>
      </div>
      <div class="add-media-container-edit-mode">
        <video-container
          *ngIf="previewData"
          [media]="previewData.mediaInfo"
          [subtitles]="previewData.mediaInfo?.subtitles"
          [audio]="previewData.mediaInfo?.audioFiles"
          [posterUrl]="previewData.mediaInfo?.contentSnapshotUrl"
          [videoUrl]="previewData.previewUrl"
        ></video-container>
      </div>
    </div>

    <div
      class="dynamic-promo-name-container"
      *ngIf="!edit"
      (dragover)="$event.preventDefault()"
      (dragenter)="onDragEnter('media')"
      (dragleave)="onDragLeave('media')"
      (drop)="onMediaDropped($event)"
    >
      <div class="dynamic-promo-name-label">NAME:</div>
      <input
        type="text"
        class="dynamic-promo-name-input"
        placeholder="Name your dynamic promo"
        [(ngModel)]="dynamicPromoInfo.name"
      />
      <a class="btn btn-export" (click)="createDynamicPromo()">Create</a>
    </div>
  </div>
  <div *ngIf="edit" class="edit-graphics-container">
    <div class="promo-details-section">
      <div class="header">Details</div>
      <table>
        <tr>
          <td class="devider"></td>
          <td></td>
        </tr>
        <tr class="field">
          <td><span>Choose Promo Media:</span></td>
          <td>
            <icn-dropdown
              [(selectedValue)]="chosenPromoMediaId"
              [disabled]="isScheduled"
              (selectedValueChange)="onPromoMediaChanged($event)"
            >
              <icn-dropdown-item
                [value]="-1"
                [title]="'Use Packshot'"
              ></icn-dropdown-item>
              <icn-dropdown-item
                *ngFor="let trailer of dynamicPromoInfo.mediaInfo.trailers"
                [value]="trailer.id"
                [title]="trailer.name"
              >
              </icn-dropdown-item>
            </icn-dropdown>
          </td>
        </tr>
        <tr>
          <td class="devider"></td>
          <td></td>
        </tr>
        <tr class="field">
          <td>
            <span>Start Graphic Offset:</span>
          </td>
          <td>
            <icn-number-input
              [min]="0"
              [step]="1"
              [contentEditable]="!isScheduled"
              [useDefaultHtmlInput]="true"
              [(value)]="dynamicPromoInfo.startGraphicOffsetSeconds"
            ></icn-number-input>
            sec
          </td>
        </tr>
      </table>
    </div>
    <icn-edit-graphics-main
      [isDynamicPromoGraphicInstance]="true"
      [defaultView]="false"
      [graphicsInfo]="dynamicPromoInfo.graphicsInfo"
    ></icn-edit-graphics-main>
  </div>
</div>
